export enum BannerProportion {
  Compact = 'compact',
  Spacious = 'spacious',
}
